const TipoTransferenciaEnum = {
    ORDEN_COMPRA: {
        tit_id: 1,
        tit_nombre: "Orden de Compra",
    },
    ENTRE_ALMACENES: {
        tit_id: 2,
        tit_nombre: "Entre Almacenes",
    },
    COMPRA_EXTERNA: {
        tit_id: 3,
        tit_nombre: "Compra Externa",
    }
}

export default TipoTransferenciaEnum